import { render, staticRenderFns } from "./NotificationAppointmentRejected.vue?vue&type=template&id=3ca2c33c&scoped=true&"
import script from "./NotificationAppointmentRejected.vue?vue&type=script&lang=ts&"
export * from "./NotificationAppointmentRejected.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca2c33c",
  null
  
)

export default component.exports